import { createReducer, on } from '@ngrx/store';
import { nextStep, noNav, repeatInstructions, startTest } from '../actions/page-content.actions';
import { PageContentState } from '../models/assessment-models';

export const initialPageContentState: PageContentState = {
  pageContent: {
    data: { nextButton: false, repeatButton: false, submitButton: false, startTestButton: false },
    loading: false,
    error: null,
  },
};

export const pageContentReducer = createReducer(
  initialPageContentState,
  on(nextStep, (state) => ({
    ...state,
    pageContent: {
      data: { nextButton: true, repeatButton: false, submitButton: false, startTestButton: false },
      loading: false,
      error: null,
    },
  })),
  on(repeatInstructions, (state) => ({
    ...state,
    pageContent: {
      data: { nextButton: false, repeatButton: true, submitButton: false, startTestButton: true },
      loading: false,
      error: null,
    },
  })),
  on(noNav, (state) => ({
    ...state,
    pageContent: {
      data: { nextButton: false, repeatButton: false, submitButton: false, startTestButton: false },
      loading: false,
      error: null,
    },
  })),
  on(startTest, (state) => ({
    ...state,
    pageContent: {
      data: { nextButton: false, repeatButton: false, submitButton: false, startTestButton: true },
      loading: false,
      error: null,
    },
  })),
);
